// extracted by mini-css-extract-plugin
export default {"Container":"CheckEmail_Container__RehHu","Title":"CheckEmail_Title__yqxTQ","DefaultText":"CheckEmail_DefaultText__kFt3a"};